module.exports = __webpack_public_path__ + "img/2.51994282.png";